import { useDeleteEmployeePromotion } from 'api-hooks/employee';
import notification from 'components/common/notification';
import useDialog from 'hooks/use-dialog';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function useDeleteEmployeePromotionDialog(employeeId: string) {
  const { t } = useTranslation();
  const deleteEmployeePromotion = useDeleteEmployeePromotion(employeeId);
  const dialog = useDialog();
  const onDeleteEmployeePromotion = React.useCallback(
    (id: string) => () => {
      dialog.showConfirmation({
        title: t('common:revert_job_level'),
        message: t('common:revert_job_level_description'),
        async onPositiveAction(dismiss) {
          try {
            const result = await deleteEmployeePromotion.mutateAsync({ id });
            notification.success({
              message: result.message,
            });
            dismiss();
          } catch (e) {
            notification.error({
              message: e.message,
            });
          } finally {
            dismiss();
          }
        },
        onNegativeAction(dismiss) {
          dismiss();
        },
      });
    },
    [deleteEmployeePromotion, dialog, t],
  );

  return {
    ...deleteEmployeePromotion,
    onDeleteEmployeePromotion,
  };
}
